import { selectMatchingVideoSource } from '../utils';

export default class AutoplayVideos {
	constructor() {
		if (!'IntersectionObserver' in window || !'ResizeObserver' in window) {
			return;
		}

		this.reduceMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
		this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
			rootMargin: '200px',
		});

		document.addEventListener('bless', (e) => {
			const container = e.target;
			this.init(container);
		});
	}

	init(container) {
		const autoplayVideos = container.querySelectorAll('[data-autoplay-video]');
		autoplayVideos.forEach((autoplayVideo) => {
			if (this.reduceMotionMediaQuery.matches) {
				autoplayVideo.classList.add('show-poster');
				return;
			}
			new Video(autoplayVideo);
			this.intersectionObserver.observe(autoplayVideo);
			this.resizeObserver.observe(autoplayVideo);
		});
	}

	handleIntersection(entries) {
		entries.forEach((entry) => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;

			// Video is in viewport
			if (ratio > 0) {
				target.dispatchEvent(new CustomEvent('play-video'));
			} else {
				target.dispatchEvent(new CustomEvent('pause-video'));
			}
		});
	}

	handleResize(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			if (!target.classList.contains('dont-update-my-source')) {
				target.dispatchEvent(new CustomEvent('select-source'));
			}
		});
	}
}

class Video {
	constructor(autoplayVideo) {
		this.elm = autoplayVideo;
		this.video = this.elm.querySelector('video');
		if (!this.video) {
			return;
		}

		this.newTime = null;
		this.shouldPlay = false;

		this.elm.addEventListener('select-source', () => {
			this.selectSource();
		});

		this.elm.addEventListener('play-video', () => {
			this.shouldPlay = true;
			this.playVideo();
		});

		this.elm.addEventListener('pause-video', () => {
			this.shouldPlay = false;
			this.pauseVideo();
		});

		this.video.addEventListener('loadedmetadata', () => {
			if (this.newTime) {
				this.video.currentTime = this.newTime;
				this.newTime = null;
			}
		});
	}

	playVideo() {
		let startPlayPromise = this.video.play();
		if (startPlayPromise !== undefined) {
			startPlayPromise
				.then(() => {
					this.elm.classList.add('is-playing');
					this.elm.classList.remove('show-poster');
				})
				.catch((error) => {
					if (!this.elm) {
						return;
					}
					setTimeout(() => {
						if (!this.elm.classList.contains('is-playing')) {
							this.elm.classList.add('show-poster');
						}
					}, 2000);
				});
		}
	}

	pauseVideo() {
		this.video.pause();
		this.elm.classList.remove('is-playing');
		this.elm.classList.add('show-poster');
	}

	selectSource() {
		this.oldTime = this.video.currentTime;
		selectMatchingVideoSource(this.video).then(() => {
			this.newTime = this.oldTime;
			if (this.shouldPlay) {
				this.playVideo();
			}
		});
	}
}
